import { render, staticRenderFns } from "./WhatsNewBar.vue?vue&type=template&id=2ce211a7&scoped=true&"
import script from "./WhatsNewBar.vue?vue&type=script&lang=js&"
export * from "./WhatsNewBar.vue?vue&type=script&lang=js&"
import style0 from "./WhatsNewBar.vue?vue&type=style&index=0&id=2ce211a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce211a7",
  null
  
)

export default component.exports